import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".p-colorpicker-preview{\n    border-radius: 50%;\n}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=colorPicker.css.js.map
